import api from "./services/mkm.api.js"

const resource = "/initiativbewerbung"

export default{
    textbloecke() {
        return api.get(`powerapps/${resource}/textbloecke`)
    },
    faecher() {
        return api.get(`${resource}/faecher`)
    },
    bezirke() {
        return api.get(`${resource}/bezirke`)
    },
    senden(payload) {
        return api.post(`${resource}`, payload)
    },
}